const blogState = {
  loader: false,
  messageSuccessMessage: "",
  messageErrorMessage: "",
  allmessages: [],
  parPage: 0,
  messageCount: 0,
};

export const messageReducer = (state = blogState, action) => {
  const { payload, type } = action;

  if (type === "SET_MESSAGE_LOADER") {
    return {
      ...state,
      loader: true,
    };
  }
  if (type === "MESSSAGE_ADD_SUCCESS") {
    return {
      ...state,
      loader: false,
      messageSuccessMessage: payload.successMessage,
      messageErrorMessage: "",
    };
  }
  if (type === "PERPAGE_MESSAGE_GET_SUCCESS") {
    return {
      ...state,
      allmessages: payload.allMessage,
      parPage: payload.parPage,
      messageCount: payload.messageCount,
    };
  }

  if(type === "MESSAGE_DELETE_SUCCESS"){
    return {
      ...state,
      messageSuccessMessage: payload,
      messageErrorMessage: "",
    }
  }

  return state;
};
